<template>
    <b-tabs expanded type="is-toggle" v-model="activeTab">
        <!-- Media TAB -->
        <b-tab-item icon="image" label="Media">
            <div class="column relative">
                <form @submit.prevent="loadData(1)">
                    <b-field style="padding-bottom: 10px">
                        <b-input expanded type="search" placeholder="Search..." v-model="query"></b-input>
                        <p class="control">
                            <b-button @click="loadData(1)" type="is-primary">Search</b-button>
                        </p>
                    </b-field>
                </form>
                <div class="columns is-multiline">
                    <div :key="file.id" class="column is-3" v-for="file in files.data">
                        <div class="pointer gallery-img">
                            <figure class="image-container">
                                <div @click="onFileSelected(file)"><img :src="file.filename_thumb" alt="Click to enlarge" class="fit" /></div>
                                <p @click="onFileSelected(file)" class="uploaded-file-name">{{ file.name }}</p>
                                <div class="trash-btn-container">
                                    <div class="trash-btn" @click="deleteFile(file.id)">
                                        <b-icon icon="delete" type="is-danger" />
                                    </div>
                                </div>
                                <div class="size-container">
                                    <div class="size-field">
                                        {{ file.size | smartFileSize }}
                                    </div>
                                </div>
                            </figure>
                        </div>
                        <!-- <footer class="card-footer" v-show="$root.profile.role == 'admin'">
                    <b-button @click="destroy(file)" class type="is-primary">Delete</b-button>
                </footer> -->
                    </div>
                </div>
                <b-pagination
                    :current.sync="page"
                    :per-page="files.per_page"
                    :range-after="3"
                    :range-before="3"
                    :total="files.total"
                    @change="loadData"
                    order="is-centered"
                    v-show="files.data"
                >
                </b-pagination>
                <b-modal :active.sync="isViewFile" v-if="viewfile">
                    <template v-if="viewfile.type == 'image'">
                        <p class="image-view" @click="isViewFile = false">
                            <img :src="viewfile.filename" />
                        </p>
                    </template>
                    <template v-if="viewfile.type == 'podcast'">
                        <div style="text-align: center">
                            <audio controls style="width: 100%">
                                <source :src="viewfile.filename" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </template>
                </b-modal>

                <b-loading :active="isLoading" :is-full-page="false" />
            </div>
        </b-tab-item>

        <!-- Upload TAB -->
        <b-tab-item icon="upload" label="Upload Files">
            <div v-if="folderId">
                <b-field :message="form.errors.get('files')" :type="{ 'is-danger': form.errors.has('files') }">
                    <b-upload :accept="$store.state.accepted_types" multiple drag-drop expanded v-model="form.files">
                        <section class="section">
                            <div class="content has-text-centered">
                                <p>
                                    <b-icon icon="upload" size="is-large"></b-icon>
                                </p>
                                <p>Drop your files here or click to upload</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
                <div class="tags" v-if="form.files.length">
                    <span class="tag is-primary" v-for="(f, idx) in form.files" :key="idx">
                        {{ f.name }}
                        <button @click="removeUpload(idx)" class="delete is-small" type="button"></button>
                    </span>
                </div>
                <b-field
                    v-for="(f, idx) in form.files"
                    :key="idx"
                    :message="form.errors.get(`files.${idx}`)"
                    :type="{ 'is-danger': form.errors.has(`files.${idx}`) }"
                >
                </b-field>
                <b-field expanded>
                    <b-button @click="doUpload" expanded type="is-primary">Upload</b-button>
                </b-field>
            </div>
            <div v-else>
                <p class="upload-note">Please select a folder.</p>
            </div>
        </b-tab-item>
    </b-tabs>
</template>
<script>
import vForm from "../../plugins/vForm";
export default {
    props: {
        input: {
            type: String,
            default: "",
        },
        folderId: {
            type: Number,
            default: null,
        },
        type: {
            type: String,
            default: "*",
        },
        picker: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            query: "",
            files: [],
            viewfile: null,
            isViewFile: false,
            activeTab: 0,
            page: 1,
            isLoading: false,
            form: new vForm({
                files: [],
                folder_id: undefined,
            }),
        };
    },
    methods: {
        async doUpload() {
            this.form.folder_id = this.folderId;
            try {
                await this.form.post("/files", {}, true);
                this.notify("Image was uploaded successfully", "is-success");
                this.activeTab = 0;
                this.page = 1;
                this.form.reset();
                this.form.clear();
                this.loadData();
            } catch (e) {
                //
            }
        },
        removeUpload(id) {
            this.form.files.splice(id, 1);
        },
        deleteFile(id) {
            this.$buefy.dialog.confirm({
                message: "Are you sure you want to remove this file?",
                confirmText: "Delete",
                type: "is-danger",
                hasIcon: true,
                onConfirm: async () => {
                    // Adding new folder
                    try {
                        await this.$http.delete(`/files/${id}`);
                        this.notify("File removed successfully.", "is-success");
                        this.loadData();
                    } catch (e) {
                        // this.notify("Failed to remove file.", "is-danger");
                    }
                },
            });
        },
        loadData() {
            this.isLoading = true;
            if (this.folderId) {
                this.$http
                    .get(`/folders/${this.folderId}/files?type=${this.type}&page=${this.page}${this.query ? "&search=" + this.query : ""}`)
                    .then((res) => {
                        this.files = res.data;
                    })
                    .finally(() => (this.isLoading = false));
            } else {
                // All
                this.$http
                    .get(`/files?type=${this.type}&page=${this.page}${this.query ? "&search=" + this.query : ""}`)
                    .then((res) => {
                        this.files = res.data;
                    })
                    .finally(() => (this.isLoading = false));
            }
        },
        reset() {
            this.page = 1;
            this.query = "";
        },
        onFileSelected(file) {
            if (this.picker) {
                this.$emit("select", file);
                return;
            }
            if (file.type == "image" || file.type == "podcast") {
                this.viewfile = file;
                this.isViewFile = true;
            } else {
                window.open(file.filename, "_blank");
            }
        },
    },
    watch: {
        folderId() {
            // Fetch new files
            this.reset();
            this.loadData();
        },
    },
    mounted() {
        this.loadData();
    },
};
</script>

<style>
img.fit {
    object-fit: cover;
    width: 100%;
    height: 100%;
}
.gallery-img {
    padding: 10px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.158);
}
/* .gallery-img * {
    width: 100%;
    height: 100%;
} */
.uploaded-file-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 0.83rem;
}
.upload-note {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
}
.image-view {
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-container {
    position: relative;
}
.trash-btn-container {
    position: absolute;
    top: 2px;
    left: 2px;
    opacity: 0;
    transition: opacity 0.15s;
    -webkit-transition: opacity 0.15s;
    transition-timing-function: ease-in-out;
}
.size-container {
    position: absolute;
    top: 0px;
    right: 0px;
    background-color: white;
    padding: 3px;
    border-radius: 0px 0px 0px 10px;
    opacity: 0;
    transition: opacity 0.15s;
    -webkit-transition: opacity 0.15s;
    transition-timing-function: ease-in-out;
}
.image-container:hover .trash-btn-container {
    opacity: 1;
}
.image-container:hover .size-container {
    opacity: 1;
}
.size-field {
    font-size: 14px;
    font-weight: bold;
}
/* .trash-btn {
    background-color: #fff;
    border-radius: 7px;
}
.trash-btn:hover {
    -webkit-filter: drop-shadow(0 0 5px red);
    cursor: pointer;
}
div.preview-container span {
    display: flex;
    flex-wrap: wrap;
} */
</style>